import React from '../services/React';
import { AUTH_ERROR } from '../services/errorCodes';
import AuthErrorMessage from './AuthErrorMessage';
import UnexpectedErrorMessage from './UnexpectedErrorMessage';

function SelectErrorMessage({ code }) {
  let errorHTML;

  switch (code) {
    case AUTH_ERROR:
      errorHTML = <AuthErrorMessage />;
      break;
    default:
      errorHTML = <UnexpectedErrorMessage />;
  }

  return errorHTML;
}

export default SelectErrorMessage;



// WEBPACK FOOTER //
// ./src/commons/components/SelectErrorMessage.jsx